import { GroupId } from '../../typings/groups';

export const CHANGE_PRIORITY_VALUE = 'CHANGE_PRIORITY_VALUE';
export type CHANGE_PRIORITY_VALUE = typeof CHANGE_PRIORITY_VALUE;

export interface PriorityValueChangeAction {
    type: CHANGE_PRIORITY_VALUE;
    groupId: GroupId;
    value: string;
}

export function changePriorityValue(groupId: GroupId, value: string): PriorityValueChangeAction {
    return {
        type: CHANGE_PRIORITY_VALUE,
        groupId,
        value
    };
}
